import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/search')({
  component: () => <Navigate replace search to="/bo/search" />,
})
